<!DOCTYPE html>
<ion-content class="content-wrapper">
  @if (showCard && rankLevelData$ | async; as rankLevelData) {
    <div class="main-container">
      <h1 class="hero-title">{{ "celebration.Congratulations" | translate }}</h1>
      <div class="vip-card">
        <div class="layer1">
          <img alt="transparent-img" src="../../../assets/icon/VIPStatus/l1.png" />
        </div>
        <div class="layer2">
          <img alt="layer-second" src="../../../assets/icon/VIPStatus/bg-purple.png" />
        </div>
        @if (userDetails$ | async; as userDetails) {
          <div class="card-layer">
            <div class="card-holder">
              <!-- name on card -->
              <h4 [ngStyle]="{ color: textColors[rankLevelData?.content?.en?.vip_status_name] }">
                {{ userDetails?.name }}
              </h4>
              <!-- vip card image -->
              <img alt="gold vip card" [src]="rankLevelData?.active_card" />
            </div>
          </div>
        }
      </div>
      <!-- vip card details -->
      <div class="vip-desc">
        <h3>You’ve levelled up to</h3>
        <h2 class="gold" [ngStyle]="{ color: titleColor[rankLevelData?.content?.en?.vip_status_name] }">
          {{ rankLevelData?.content?.en.vip_status_name }}<br /><small> VIP Status</small>
        </h2>
        <div class="features">
          <p>You now get-</p>
          <ul>
            <li [innerHTML]="rankLevelData?.content?.en?.celebration_benefits?.[1]?.text"></li>
            <li [innerHTML]="rankLevelData?.content?.en?.celebration_benefits?.[2]?.text"></li>
            <li [innerHTML]="rankLevelData?.content?.en?.celebration_benefits?.[3]?.text" class="new-badge">
              <span
                ><svg width="33" height="14" viewBox="0 0 33 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>New</title>
                <rect width="33" height="14" fill="#FF4510" />
                <path
                  d="M4.35062 11C4.26262 11 4.19062 10.972 4.13462 10.916C4.07862 10.86 4.05062 10.788 4.05062 10.7V2.9C4.05062 2.812 4.07862 2.74 4.13462 2.684C4.19062 2.628 4.26262 2.6 4.35062 2.6H5.62262C5.75862 2.6 5.85462 2.632 5.91062 2.696C5.97462 2.752 6.01462 2.796 6.03062 2.828L8.95862 7.448V2.9C8.95862 2.812 8.98662 2.74 9.04262 2.684C9.09862 2.628 9.17062 2.6 9.25862 2.6H10.6986C10.7866 2.6 10.8586 2.628 10.9146 2.684C10.9706 2.74 10.9986 2.812 10.9986 2.9V10.7C10.9986 10.78 10.9706 10.852 10.9146 10.916C10.8586 10.972 10.7866 11 10.6986 11H9.41462C9.28662 11 9.19062 10.968 9.12662 10.904C9.07062 10.84 9.03462 10.796 9.01862 10.772L6.09062 6.332V10.7C6.09062 10.788 6.06262 10.86 6.00662 10.916C5.95062 10.972 5.87862 11 5.79062 11H4.35062ZM13.14 11C13.052 11 12.98 10.972 12.924 10.916C12.868 10.86 12.84 10.788 12.84 10.7V2.9C12.84 2.812 12.868 2.74 12.924 2.684C12.98 2.628 13.052 2.6 13.14 2.6H18.744C18.832 2.6 18.904 2.628 18.96 2.684C19.016 2.74 19.044 2.812 19.044 2.9V4.028C19.044 4.116 19.016 4.188 18.96 4.244C18.904 4.3 18.832 4.328 18.744 4.328H14.916V5.948H18.48C18.568 5.948 18.64 5.98 18.696 6.044C18.752 6.1 18.78 6.172 18.78 6.26V7.304C18.78 7.384 18.752 7.456 18.696 7.52C18.64 7.576 18.568 7.604 18.48 7.604H14.916V9.272H18.84C18.928 9.272 19 9.3 19.056 9.356C19.112 9.412 19.14 9.484 19.14 9.572V10.7C19.14 10.788 19.112 10.86 19.056 10.916C19 10.972 18.928 11 18.84 11H13.14ZM22.0124 11C21.8764 11 21.7684 10.96 21.6884 10.88C21.6084 10.8 21.5604 10.708 21.5444 10.604L20.2364 2.936C20.2284 2.92 20.2244 2.904 20.2244 2.888C20.2244 2.872 20.2244 2.86 20.2244 2.852C20.2244 2.788 20.2484 2.732 20.2964 2.684C20.3524 2.628 20.4124 2.6 20.4764 2.6H21.9644C22.1884 2.6 22.3124 2.688 22.3364 2.864L23.1164 7.556L23.9804 4.784C24.0044 4.72 24.0444 4.652 24.1004 4.58C24.1564 4.5 24.2484 4.46 24.3764 4.46H25.2404C25.3764 4.46 25.4724 4.5 25.5284 4.58C25.5844 4.652 25.6204 4.72 25.6364 4.784L26.5004 7.544L27.2804 2.864C27.3044 2.688 27.4284 2.6 27.6524 2.6H29.1404C29.2124 2.6 29.2724 2.628 29.3204 2.684C29.3684 2.732 29.3924 2.788 29.3924 2.852C29.3924 2.86 29.3924 2.872 29.3924 2.888C29.3924 2.904 29.3924 2.92 29.3924 2.936L28.0844 10.604C28.0684 10.708 28.0204 10.8 27.9404 10.88C27.8604 10.96 27.7524 11 27.6164 11H26.4764C26.3404 11 26.2364 10.964 26.1644 10.892C26.0924 10.82 26.0444 10.752 26.0204 10.688L24.8084 7.256L23.5964 10.688C23.5724 10.752 23.5244 10.82 23.4524 10.892C23.3884 10.964 23.2884 11 23.1524 11H22.0124Z"
                  fill="white"
                  />
                </svg>
              </span>
            </li>
          </ul>
        </div>
        <!-- <button class="close-btn" (click)="closeDialog()">OK</button> -->
      </div>
    </div>
  }
  <!-- VIP RANK LEVEL UP Video -->
  <div class="video-wrapper" #videoWrapper>
    <video #videoPlayer [autoplay]="true" playsinline>
      <source [src]="videoPath" type="video/mp4" />
    </video>
  </div>
  @if (showCard && rankLevelData$ | async; as rankLevelData) {
    <div class="close-button-container">
      <button class="close-btn" type="button" [disabled]="isClosing" (click)="closeDialog()">OK</button>
    </div>
  }
</ion-content>